export default {
  methods: {
    removeWhitespace (string) {
      return string.replace(/\s+/g, '')
    },
  },
};